export function awaitLoading (gridInstance) {
  return new Promise((resolve) => {
    let cont = 0
    let int = setInterval(() => {
      let total = gridInstance.totalCount()
      if (total !== -1 || cont === 10) {
        clearInterval(int)
        return resolve()
      }
      cont++
    }, 100)
  })
}
